export enum ConsultantTableColumns {
  CreatedAt = "CreatedAt",
  UpdatedAt = "UpdatedAt",
  Address = "Address",
  AreasOfExpertise = "AreasOfExpertise",
  Availability = "Availability",
  AvailableForWorkIn = "AvailableForWorkIn",
  Comments = "Comments",
  Email = "Email",
  GDPRIntegrationPolicy = "GDPRIntegrationPolicy",
  GDPRJobMailing = "GDPRJobMailing",
  GDPRLegalBasis = "GDPRLegalBasis",
  GDPRMarketing = "GDPRMarketing",
  HOSP = "HOSP",
  HasDrivingLicense = "HasDrivingLicense",
  IVO = "IVO",
  IVOErrands = "IVOErrands",
  InterestedToWorkIn = "InterestedToWorkIn",
  IsNationalQualityApproved = "IsNationalQualityApproved",
  IsQualityApproved = "IsQualityApproved",
  LastContactDate = "LastContactDate",
  Machines = "Machines",
  MethodsAndInstruments = "MethodsAndInstruments",
  Name = "Name",
  OtherEducations = "OtherEducations",
  Phone = "Phone",
  ResponsiblePerson = "ResponsiblePerson",
  SocialSecurityNo = "SocialSecurityNo",
  Specializations = "Specializations",
  SwedenBusinessIntelligence = "SwedenBusinessIntelligence",
  SwedenCVAudit = "SwedenCVAudit",
  SwedenCriminalRecord = "SwedenCriminalRecord",
  SwedenHSAIDSITHS = "SwedenHSAIDSITHS",
  SwedenHealthDeclaration = "SwedenHealthDeclaration",
  SwedenIdCheck = "SwedenIdCheck",
  SwedenInterviewDone = "SwedenInterviewDone",
  SwedenHLR = "SwedenHLR",
  SwedenSAHLR = "SwedenSAHLR",
  SwedenLanguageCheck = "SwedenLanguageCheck",
  SwedenNationalReferences = "SwedenNationalReferences",
  SwedenNpCriminalRecord = "SwedenNpCriminalRecord",
  SwedenProofOfEducation = "SwedenProofOfEducation",
  SwedenProofOfWork = "SwedenProofOfWork",
  SwedenReferences = "SwedenReferences",
  Systems = "Systems",
  WorksForCompetitors = "WorksForCompetitors",
  CallListStats = "CallListStats",
  Tags = "Tags",
  NextContactDate = "NextContactDate",
  PipelineStatus = "PipelineStatus",
  BookingStatus = "BookingStatus",
  QualityNote = "QualityNote"
}
